import React, { useRef, useState, useEffect } from "react";
import "./App.css";

import screenshot from "./assets/screenshot.jpg";
import vid from "./assets/noiselund.mp4";

import { useMastodonPost } from "./hooks/useMastodonPost";
import { usePixelfedPost } from "./hooks/usePixelfedPost";
import { useLoopsPost } from "./hooks/useLoopsPost";
import { SocialPostCard } from "./components/SocialPostCard";

function App() {
  const ref = useRef<HTMLVideoElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const mastodon = useMastodonPost();
  const pixelfed = usePixelfedPost();
  const loops = useLoopsPost();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY ?? document.documentElement.scrollTop ?? document.body.scrollTop ?? 0;
      setIsScrolled(scrollTop > 100);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("scroll", handleScroll, { passive: true });
    // Check initial scroll position
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleSound = () => {
    if (ref.current) {
      ref.current.muted = !ref.current.muted;
    }
  };

  return (
    <div className="App">
      <header className={`video-header ${isScrolled ? "scrolled" : ""}`}>
        <video
          ref={ref}
          autoPlay
          muted
          controls
          loop
          playsInline
          poster={screenshot}
          preload="auto"
        >
          <source src={vid} type="video/mp4" />
          selaimesi ei tue html5 videoita
        </video>
      </header>

      <main>
        <div className="btn-div">
          <button onClick={toggleSound} className="button">
            <span>unmute </span>
          </button>
        </div>
        <div className="links-div">
          <div>
            <a
              rel="me"
              href="https://mastodontti.fi/@elias"
              data-testid="mastodon-link"
            >
              mastodon
            </a>
          </div>
          <div>
            <a
              href="https://bsky.app/profile/elias.bsky.fi"
              data-testid="bsky-link"
            >
              bsky
            </a>
          </div>
          <div>
            <a
              href="https://loops.video/@elias"
              data-testid="loops-link"
            >
              loops
            </a>
          </div>
          <div>
            <a
              href="https://pixl.fi/elias"
              data-testid="pixelfed-link"
            >
              pixelfed
            </a>
          </div>
        </div>
        
        <div className="social-feeds-container">
          <SocialPostCard
            platform="mastodon"
            postUrl={mastodon.post?.url ?? "https://mastodontti.fi/@elias"}
            content={mastodon.post?.content}
            imageUrl={mastodon.post?.cardImage}
            date={mastodon.post?.createdAt}
            loading={mastodon.loading}
            error={mastodon.error}
          />
          <SocialPostCard
            platform="pixelfed"
            postUrl={pixelfed.post?.postUrl ?? "https://pixl.fi/elias"}
            imageUrl={pixelfed.post?.imageUrl}
            caption={pixelfed.post?.title}
            date={pixelfed.post?.date}
            loading={pixelfed.loading}
            error={pixelfed.error}
          />
          <SocialPostCard
            platform="loops"
            postUrl={loops.post?.url ?? "https://loops.video/@elias"}
            content={loops.post?.content}
            date={loops.post?.published}
            loading={loops.loading}
            error={loops.error}
          />
        </div>
      </main>
    </div>
  );
}

export default App;
